// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"972f6387","83":"0b408227","86":"2835d319","185":"c5b39c02","235":"788d2569","289":"ec91b53b","365":"0af99d4a","484":"94bac957","519":"71635da8","644":"b0b0abfb","749":"480aa3b1","803":"e298ab48","852":"179889b6","921":"4cda2a6b","955":"e20a66c6","956":"d89d011b"}[chunkId] + ".chunk.js";
};